/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_MessageInputs */

const en_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
};

const fr_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur : ${i?.error}`)
};

const de_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler: ${i?.error}`)
};

const it_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore: ${i?.error}`)
};

const ru_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка: ${i?.error}`)
};

const es_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
};

const zh_cn2_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`错误：${i?.error}`)
};

const ja_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラー: ${i?.error}`)
};

const hi_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`त्रुटि: ${i?.error}`)
};

const pt_pt2_error_message = /** @type {(inputs: Error_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error: {error}" |
*
* @param {Error_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_message = /** @type {((inputs: Error_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_message(inputs)
	if (locale === "de") return de_error_message(inputs)
	if (locale === "it") return it_error_message(inputs)
	if (locale === "ru") return ru_error_message(inputs)
	if (locale === "es") return es_error_message(inputs)
	if (locale === "zh-CN") return zh_cn2_error_message(inputs)
	if (locale === "ja") return ja_error_message(inputs)
	if (locale === "hi") return hi_error_message(inputs)
	if (locale === "pt-PT") return pt_pt2_error_message(inputs)
	return en_error_message(inputs)
});